import { useState } from 'react';
import DatePicker, { registerLocale } from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import vi from 'date-fns/locale/vi';
import { Table, Typography } from 'antd';
import { MagnifyingGlassIcon } from '@heroicons/react/24/outline';

import './table.scss';
import { dataListPlayerGrid, ListPlayerGrid } from '~/data/dummy';
import { useStateContext } from '~/contexts/ContextProvider';

const { Text } = Typography;
registerLocale('vi', vi);

const getDate = (type) => {
  let beginDate = new Date();
  let endDate = new Date();

  if (type === 'preDay') {
    beginDate.setDate(beginDate.getDate() - 2);
    endDate.setDate(endDate.getDate() - 1);
  }
  if (type === 'today') {
    endDate.setDate(endDate.getDate() + 1);
  }
  if (type === 'thisWeek') {
    beginDate.setDate(beginDate.getDate() - beginDate.getDay() + 1);
    endDate.setDate(endDate.getDate() + 7 - endDate.getDay());
  }
  if (type === 'preWeek') {
    beginDate.setDate(beginDate.getDate() - beginDate.getDay() - 6);
    endDate.setDate(endDate.getDate() - endDate.getDay());
  }
  if (type === 'thisMonth') {
    beginDate = new Date(beginDate.getFullYear(), beginDate.getMonth(), 1);
    endDate = new Date(endDate.getFullYear(), endDate.getMonth() + 1, 0);
  }
  if (type === 'preMonth') {
    beginDate = new Date(beginDate.getFullYear(), beginDate.getMonth() - 1, 1);
    endDate = new Date(endDate.getFullYear(), endDate.getMonth(), 0);
  }
  if (type === 'pre7Day') {
    beginDate.setDate(beginDate.getDate() - 7);
  }
  if (type === 'pre30Day') {
    beginDate.setDate(beginDate.getDate() - 30);
  }
  return { beginDate, endDate };
};

const ListPlayer = () => {
  const { formatMoney } = useStateContext();
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());
  const [buttonActiveTab, setButtonActiveTab] = useState('today');
  const handleDateForm = (type) => {
    setStartDate(getDate(type).beginDate);
    setEndDate(getDate(type).endDate);
    setButtonActiveTab(type);
  };
  const listPlayerGrid = ListPlayerGrid();
  return (
    <div className="">
      <div className="border-b w-full flex flex-col items-center">
        <div className="flex w-full items-center">
          <div className="w-1/2">
            <span className=" w-full">Tài khoản thành viên</span>
            <div className="flex">
              <select
                name=""
                id="utc"
                className="border rounded-sm w-full px-2 py-1.5 focus:outline-none">
                <option value="+7">Tìm kiếm chính xác</option>
                <option value="+7">Tìm kiếm xấp xỉ</option>
              </select>
              <input
                type="text"
                className="border rounded-sm w-full px-2 py-1.5 focus:outline-none"
              />
            </div>
          </div>
          <div className="flex w-1/2">
            <div className="flex flex-col w-full">
              <label htmlFor="name">Tên thật</label>
              <input
                type="text"
                id="name"
                className="border rounded-sm w-full px-2 py-1.5 focus:outline-none"
              />
            </div>
            <div className=" flex flex-col w-full">
              <label htmlFor="type">Nhóm đại lý</label>
              <select
                name=""
                id="type"
                className="border rounded-sm w-full px-2 py-1.5 focus:outline-none">
                <option value="">--Chọn--</option>
                <option value="">Nhóm 1</option>
                <option value="">Nhóm 2</option>
                <option value="">Nhóm 3</option>
                <option value="">Nhóm 4</option>
                <option value="">Nhóm 5</option>
              </select>
            </div>
          </div>
        </div>
        <div className="flex w-full items-center mt-4">
          <div className="w-1/2">
            <span className=" w-full">
              Tìm kiếm theo thời gian{' '}
              <span className="text-red-500">* Kiểm tra báo cáo đại lý 60 ngày gần đây</span>
            </span>
            <div className="flex">
              <DatePicker
                className="p-2 rounded-sm w-full border text-sm"
                selected={startDate}
                dateFormat="yyyy/MM/dd"
                locale="vi"
                onChange={(date) => {
                  setStartDate(date);
                }}
              />
              <DatePicker
                className="p-2 rounded-sm w-full border text-sm"
                selected={endDate}
                dateFormat="yyyy/MM/dd"
                locale="vi"
                onChange={(date) => {
                  setEndDate(date);
                }}
              />
            </div>
          </div>
          <div className="flex w-1/2">
            <div className="flex flex-col w-full">
              <label htmlFor="utc">Múi giờ</label>
              <select
                name=""
                id="utc"
                className="border rounded-sm w-full px-2 py-1.5 focus:outline-none">
                <option value="+7">UTC+7:00</option>
              </select>
            </div>
            <div className=" flex flex-col w-full">
              <label htmlFor="type">Tên nhãn</label>
              <select
                name=""
                id="type"
                className="border rounded-sm w-full px-2 py-1.5 focus:outline-none">
                <option value="id">--Chọn--</option>
              </select>
            </div>
          </div>
        </div>
        <div className="flex w-full items-center mt-4">
          <div className="flex flex-col w-full">
            <label htmlFor="name">Nạp tiền gần nhất</label>
            <input
              type="text"
              id="name"
              className="border rounded-sm w-full px-2 py-1.5 focus:outline-none"
            />
          </div>
          <div className="flex flex-col w-full">
            <label htmlFor="name">Nạp tiền cao nhất</label>
            <input
              type="text"
              id="name"
              className="border rounded-sm w-full px-2 py-1.5 focus:outline-none"
            />
          </div>
          <div className="flex flex-col w-full">
            <label htmlFor="name">Số tiền rút thấp nhất</label>
            <input
              type="text"
              id="name"
              className="border rounded-sm w-full px-2 py-1.5 focus:outline-none"
            />
          </div>
          <div className="flex flex-col w-full">
            <label htmlFor="name">Số tiền rút cao nhất</label>
            <input
              type="text"
              id="name"
              className="border rounded-sm w-full px-2 py-1.5 focus:outline-none"
            />
          </div>
        </div>
        <div className="flex w-full items-center mt-4">
          <div className="flex flex-col w-full">
            <label htmlFor="name">Cược hợp lệ nhỏ hơn</label>
            <input
              type="text"
              id="name"
              className="border rounded-sm w-full px-2 py-1.5 focus:outline-none"
            />
          </div>
          <div className="flex flex-col w-full">
            <label htmlFor="name">Cược hợp lệ lớn hơn</label>
            <input
              type="text"
              id="name"
              className="border rounded-sm w-full px-2 py-1.5 focus:outline-none"
            />
          </div>
          <div className="flex flex-col w-full">
            <label htmlFor="name">Tổng thắng/thua thấp nhất</label>
            <input
              type="text"
              id="name"
              className="border rounded-sm w-full px-2 py-1.5 focus:outline-none"
            />
          </div>
          <div className="flex flex-col w-full">
            <label htmlFor="name">Tổng thắng/thua cao nhất</label>
            <input
              type="text"
              id="name"
              className="border rounded-sm w-full px-2 py-1.5 focus:outline-none"
            />
          </div>
        </div>

        <button className="flex items-center bg-[#01b1f0] text-white px-3 py-1 rounded-md my-4 justify-self-center">
          <MagnifyingGlassIcon width="18" />
          Tìm kiếm
        </button>
      </div>
      <div className="mt-4">
        <h3 className="text-2xl font-medium">Báo cáo đại lý tuyến trên</h3>
        <span className="text-[red] text-sm">
          (Báo cáo này sẽ hiển thị các đại lý cấp dưới hiện tại và dữ liệu của họ. Nếu cần kết toán
          với đại lý, vui lòng lưu dữ liệu trước khi đổi tuyến đại lý，Hệ thống kết toán lúc
          00:00~01:00(GMT+8). Vui lòng kiểm tra dữ liệu sau khi kết toán)
        </span>
        <Table
          rowKey="id"
          dataSource={dataListPlayerGrid}
          columns={listPlayerGrid}
          // loading={loading}
          bordered
          pagination={{
            defaultPageSize: 50,
            showSizeChanger: true,
            pageSizeOptions: ['50', '100', '150'],
            showQuickJumper: true,
          }}
          summary={(pageData) => {
            let totalTimeRecharge = pageData.reduce((pre, current) => {
              return pre + (current.totalTimeRecharge || 0);
            }, 0);
            let totalTimeWithdrawal = pageData.reduce((pre, current) => {
              return pre + (current.totalTimeWithdrawal || 0);
            }, 0);

            let recharge = pageData.reduce((pre, current) => {
              return pre + current.recharge;
            }, 0);
            let withdrawal = pageData.reduce((pre, current) => {
              return pre + current.withdrawal;
            }, 0);
            let handEdit = pageData.reduce((pre, current) => {
              return pre + current.handEdit;
            }, 0);
            let totalBet = pageData.reduce((pre, current) => {
              return pre + current.totalBet;
            }, 0);
            let legitBet = pageData.reduce((pre, current) => {
              return pre + current.legitBet;
            }, 0);
            let win = pageData.reduce((pre, current) => {
              return pre + current.win;
            }, 0);
            let lose = pageData.reduce((pre, current) => {
              return pre + current.lose;
            }, 0);
            return (
              <>
                <Table.Summary.Row>
                  <Table.Summary.Cell>Tổng</Table.Summary.Cell>
                  <Table.Summary.Cell></Table.Summary.Cell>
                  <Table.Summary.Cell>
                    <Text>{totalTimeRecharge}</Text>
                  </Table.Summary.Cell>
                  <Table.Summary.Cell>
                    <Text>{formatMoney(recharge)}</Text>
                  </Table.Summary.Cell>
                  <Table.Summary.Cell>
                    <Text>{totalTimeWithdrawal}</Text>
                  </Table.Summary.Cell>
                  <Table.Summary.Cell>
                    <Text>{formatMoney(withdrawal)}</Text>
                  </Table.Summary.Cell>
                  <Table.Summary.Cell>
                    <Text>{handEdit}</Text>
                  </Table.Summary.Cell>
                  <Table.Summary.Cell>
                    <Text>{formatMoney(totalBet)}</Text>
                  </Table.Summary.Cell>
                  <Table.Summary.Cell>
                    <Text>{legitBet}</Text>
                  </Table.Summary.Cell>
                  <Table.Summary.Cell>
                    <Text>
                      {win}/{lose}
                    </Text>
                  </Table.Summary.Cell>
                  <Table.Summary.Cell colSpan={3}></Table.Summary.Cell>
                </Table.Summary.Row>
              </>
            );
          }}
        />
      </div>
    </div>
  );
};

export default ListPlayer;
